// extracted by mini-css-extract-plugin
export var notificationHost = "_ia-0";